module.exports = __webpack_public_path__ + "media/assets/back-icon-c733a880.png";